import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import ContentCreatorInvitation from './content-creator-invitation-model'
import {
  CreateContentCreatorInvitationAsync,
  DeleteContentCreatorInvitationAsync,
  LoadContentCreatorInvitationsAsync,
} from './contentCreatorInvitation-thunk'
const initialState: contentCreatorInvitationSliceState = {
  contentCreatorInvitation: [],
  selected_contentCreatorInvitation: '',
  is_loading_contentCreatorInvitation: false,
  is_creating_contentCreatorInvitation: false,
  is_deleting_contentCreatorInvitation: false,
}
export interface contentCreatorInvitationSliceState {
  contentCreatorInvitation: ContentCreatorInvitation[]
  selected_contentCreatorInvitation?: string
  is_loading_contentCreatorInvitation: boolean
  is_creating_contentCreatorInvitation: boolean
  is_deleting_contentCreatorInvitation: boolean
}
export const contentCreatorInvitationSlice = createSlice({
  name: 'contentCreatorInvitation',
  initialState,
  reducers: {
    setSelectedcontentCreatorInvitation: (state, action) => {
      state.selected_contentCreatorInvitation = action.payload
    },
    clearStatecontentCreatorInvitation: (state) => {
      state.contentCreatorInvitation = []
      state.is_loading_contentCreatorInvitation = false
      state.is_creating_contentCreatorInvitation = false
      state.is_deleting_contentCreatorInvitation = false
    },
    mergecontentCreatorInvitation: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_contentCreatorInvitation = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.contentCreatorInvitation = merge(
            state.contentCreatorInvitation,
            payload,
          ) as any
        }
      }
    },

    add_contentCreatorInvitation: (state, action) => {
      if (action.payload) {
        state.contentCreatorInvitation = [
          ...state.contentCreatorInvitation,
          action.payload,
        ]
      }
    },
    set_contentCreatorInvitation: (state, action) => {
      let { key, value, id } = action.payload
      state.contentCreatorInvitation = state.contentCreatorInvitation.map(
        (item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        },
      )
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadContentCreatorInvitationsAsync.pending, (state) => {
      state.is_loading_contentCreatorInvitation = true
    })
    builder.addCase(
      LoadContentCreatorInvitationsAsync.fulfilled,
      (state, action) => {
        state.is_loading_contentCreatorInvitation = false
        if (action.payload) {
          state.contentCreatorInvitation = action.payload
        }
      },
    )
    builder.addCase(LoadContentCreatorInvitationsAsync.rejected, (state) => {
      state.is_loading_contentCreatorInvitation = false
    })
    builder.addCase(CreateContentCreatorInvitationAsync.pending, (state) => {
      state.is_creating_contentCreatorInvitation = true
    })
    builder.addCase(CreateContentCreatorInvitationAsync.fulfilled, (state) => {
      state.is_creating_contentCreatorInvitation = false
    })
    builder.addCase(CreateContentCreatorInvitationAsync.rejected, (state) => {
      state.is_creating_contentCreatorInvitation = false
    })
    builder.addCase(DeleteContentCreatorInvitationAsync.pending, (state) => {
      state.is_deleting_contentCreatorInvitation = true
    })
    builder.addCase(
      DeleteContentCreatorInvitationAsync.fulfilled,
      (state, action) => {
        state.is_deleting_contentCreatorInvitation = false
        if (state.contentCreatorInvitation) {
          state.contentCreatorInvitation =
            state.contentCreatorInvitation.filter(
              (x) => action.payload.id !== x.id,
            )
        }
      },
    )
    builder.addCase(DeleteContentCreatorInvitationAsync.rejected, (state) => {
      state.is_deleting_contentCreatorInvitation = false
    })

    builder.addCase(
      autoThunks.load_my_content_house_invitations.pending,
      (state) => {
        state.is_loading_contentCreatorInvitation = true
      },
    )
    builder.addCase(
      autoThunks.load_my_content_house_invitations.fulfilled,
      (state, action) => {
        state.is_loading_contentCreatorInvitation = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.load_my_content_house_invitations.rejected,
      (state) => {
        state.is_loading_contentCreatorInvitation = false
      },
    )

    builder.addCase(autoThunks.reject_invitation.pending, (state) => {
      state.is_loading_contentCreatorInvitation = true
    })
    builder.addCase(autoThunks.reject_invitation.fulfilled, (state, action) => {
      state.is_loading_contentCreatorInvitation = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.reject_invitation.rejected, (state) => {
      state.is_loading_contentCreatorInvitation = false
    })

    builder.addCase(autoThunks.accept_invitation.pending, (state) => {
      state.is_loading_contentCreatorInvitation = true
    })
    builder.addCase(autoThunks.accept_invitation.fulfilled, (state, action) => {
      state.is_loading_contentCreatorInvitation = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.accept_invitation.rejected, (state) => {
      state.is_loading_contentCreatorInvitation = false
    })
  },
})

function handleResult(action: any, state: contentCreatorInvitationSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_contentCreatorInvitation = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.contentCreatorInvitation = merge(
        state.contentCreatorInvitation,
        payload,
      ) as any
    }
  }
}

export const {
  clearStatecontentCreatorInvitation,
  setSelectedcontentCreatorInvitation,
  set_contentCreatorInvitation,
  mergecontentCreatorInvitation,
  add_contentCreatorInvitation,
} = contentCreatorInvitationSlice.actions

export const get_contentCreatorInvitation =
  (id?: string) =>
  (state: {
    contentCreatorInvitation: {
      contentCreatorInvitation: ContentCreatorInvitation[]
    }
  }): ContentCreatorInvitation | null => {
    let temp = state?.contentCreatorInvitation?.contentCreatorInvitation?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.contentCreatorInvitation?.contentCreatorInvitation[0] || null
  }
export const get_selected_contentCreatorInvitation = (state: {
  contentCreatorInvitation: contentCreatorInvitationSliceState
}): ContentCreatorInvitation | null => {
  let id = state?.contentCreatorInvitation?.selected_contentCreatorInvitation
  let temp = state?.contentCreatorInvitation?.contentCreatorInvitation?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_contentCreatorInvitation = (state: {
  contentCreatorInvitation: {
    contentCreatorInvitation: ContentCreatorInvitation[]
  }
}): ContentCreatorInvitation[] => {
  let temp = state?.contentCreatorInvitation?.contentCreatorInvitation
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_contentCreatorInvitation_busy = (state: {
  contentCreatorInvitation: contentCreatorInvitationSliceState
}) => {
  return (
    state?.contentCreatorInvitation.is_deleting_contentCreatorInvitation ||
    state?.contentCreatorInvitation.is_loading_contentCreatorInvitation ||
    state?.contentCreatorInvitation.is_creating_contentCreatorInvitation
  )
}
export const is_deleting_contentCreatorInvitation_busy = (state: {
  contentCreatorInvitation: contentCreatorInvitationSliceState
}) => {
  return state?.contentCreatorInvitation.is_deleting_contentCreatorInvitation
}
export const is_loading_contentCreatorInvitation_busy = (state: {
  contentCreatorInvitation: contentCreatorInvitationSliceState
}) => {
  return state?.contentCreatorInvitation.is_loading_contentCreatorInvitation
}
export const is_creating_contentCreatorInvitation_busy = (state: {
  contentCreatorInvitation: contentCreatorInvitationSliceState
}) => {
  return state?.contentCreatorInvitation.is_creating_contentCreatorInvitation
}

export default contentCreatorInvitationSlice.reducer
